import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { useBookingForAssistanceSearchTable } from './utils';
import { Spinner } from 'admin-components/components';
import AgentPortalError from 'errors/AgentPortalError';
import { GET_STATIONS, GET_BOOKINGS_WITH_WHEELCHAIR_OR_SPECIAL_ASSISTANCE } from 'store/queries';
import { ACTION_CODES } from 'constants/errors';
import BookingSearchTable from './BookingSearchTable';
import BookingSearchSummary from './BookingSearchSummary';
import { BookingSearchOnHoldResultsHeader } from './BookingOnHoldSearchResults.styles';

const BookingAssistanceSearchResults = (props) => {
  const { data: { stations } = { stations: [] } } = useQuery(GET_STATIONS, { fetchPolicy: 'network-only' });
  const stationUic = props.detailKey.split('_').pop();

  const departureDate = useMemo(() => {
    const { year, month, date } = props.detailKey.match(/ASSISTANCE_(?<year>\d+)_(?<month>\d+)_(?<date>\d+)_\w+/).groups;

    return new Date(year, Number(month) - 1, date);
  }, [props.detailKey]);

  const formattedDepartureDate = moment(new Date(departureDate)).format('YYYY-MM-DD');

  const { data, error, loading } = useQuery(GET_BOOKINGS_WITH_WHEELCHAIR_OR_SPECIAL_ASSISTANCE, {
    variables: {
      date: formattedDepartureDate,
      station: stationUic
    }
  });

  const bookings = useBookingForAssistanceSearchTable(data?.bookingsWithWheelchairOrSpecialAssistance);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    throw new AgentPortalError(error, ACTION_CODES.REDIRECT_TO_CUSTOM_PAGE, {
      errorCTARedirect: '/search/booking'
    });
  }

  return (
    <>
      <BookingSearchOnHoldResultsHeader>
        <div>
          <BookingSearchSummary
            noOfPnrsFound={bookings.length}
            station={stations?.find(({ uic }) => uic === stationUic)?.name || ''}
            depArrDate={departureDate}
          />
        </div>
      </BookingSearchOnHoldResultsHeader>
      {Boolean(bookings.length) && (
        <BookingSearchTable
          bookings={bookings}
          removeColumns={['minorsAmount', 'paymentDue', 'passengerCount', 'returningOn', 'masterReference']}
          columnsAssistances={true}
        />
      )}
    </>
  );
};

BookingAssistanceSearchResults.propTypes = {
  detailKey: PropTypes.string.isRequired,
  detailValue: PropTypes.string.isRequired
};

export default BookingAssistanceSearchResults;
